import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { flowRight, omit, pick } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { getContext, withProps } from 'recompose';
import { Field, fieldPropTypes } from 'redux-form';

import Error from '../../Error';
import FieldInfo from '../FieldInfo';
import withScroll from '../withScroll';
import { withDisableField } from './TypedDisabled';

import './PasswordField.scss';

const inputProps = ['placeholder', 'disabled', 'autoComplete'];

const PasswordFieldInner = ({
    formGroup: Group,
    input: { name, value, ...input },
    info,
    meta,
    required,
    classNameInput,
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
    };

    return (
        <Group component="label" htmlFor={name} {...omit(inputProps, props)} required={required}>
            <div className="password-field__wrapper">
                <input
                    id={name}
                    className={`password-field__input${value ? ' filled' : ''} ${classNameInput}`}
                    name={name}
                    value={value}
                    required={required}
                    {...pick(inputProps, props)}
                    {...input}
                    type={showPassword ? 'text' : 'password'}
                />
                <button
                    type="button"
                    className="password-field__toggle"
                    onClick={togglePasswordVisibility}
                >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
            </div>
            {info ? <FieldInfo id={name}>{info}</FieldInfo> : null}
            <span className="validation-feedback" />
            <Error {...meta} />
        </Group>
    );
};

PasswordFieldInner.propTypes = {
    ...fieldPropTypes,
    formGroup: PropTypes.func.isRequired,
    required: PropTypes.bool,
};

PasswordFieldInner.defaultProps = {
    required: false,
};

const PasswordField = flowRight([
    withDisableField(),
    withProps({ component: PasswordFieldInner }),
    getContext({ formGroup: PropTypes.func.isRequired }),
    withScroll,
])(Field);

export default PasswordField;
